import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PermissionRequest } from '../models/requests/new-permission';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { RolePermissionDto } from '../models/RolePermissionDto';
import { SystemPermissionDto } from '../models/SystemPermission';

@Injectable({
  providedIn: 'root'
})
export class RolePermissionService {

  constructor(private httpClient: HttpClient) { }
  getByRoleId(roleId:number): Observable<ApiResponseObject<RolePermissionDto[]>> {
    return this.httpClient.get<ApiResponseObject<RolePermissionDto[]>>(`${environment.apiUrl}/RolePermissions/getPermissionforRole?roleId=` +roleId);
  }
  
  saveLocation(request: RolePermissionDto): Observable<ApiResponseObject<RolePermissionDto>> {
   
    return this.httpClient.post<ApiResponseObject<RolePermissionDto>>(`${environment.apiUrl}/RolePermissions`, request);
  }

  getPermissions(): Observable<ApiResponseObject<SystemPermissionDto[]>> {
    return this.httpClient.get<ApiResponseObject<SystemPermissionDto[]>>(`${environment.apiUrl}/Permissions`);
  }

  addPermission(request: PermissionRequest): Observable<ApiResponseObject<RolePermissionDto>> {
   
    return this.httpClient.post<ApiResponseObject<RolePermissionDto>>(`${environment.apiUrl}/RolePermissions/addrolepermission`, request);
  }

  updatePermission(request: RolePermissionDto): Observable<ApiResponseObject<RolePermissionDto>> {
   
    return this.httpClient.put<ApiResponseObject<RolePermissionDto>>(`${environment.apiUrl}/RolePermissions/update`, request);
  }
}
